/* eslint-disable @typescript-eslint/no-unsafe-call -- too tired for types gymnastics*/
/* eslint-disable @typescript-eslint/no-shadow -- too tired for types gymnastics */
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- too tired for types gymnastics */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- too tired for types gymnastics */
/* eslint-disable @typescript-eslint/no-invalid-void-type -- too tired for types gymnastics */
/* eslint-disable @typescript-eslint/no-explicit-any -- We want to allow any type for the values */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents -- it's oke*/
import { useState } from "react";
import type { ValidationError, Schema } from "yup";

export type Register = (
  key: keyof Values,
  map?: ((v: Value) => Value) | undefined,
  mask?: string // Replace anything that is _
) => {
  name: string;
  value: any;
  onChange: (e: any) => void;
  error: any;
};

export const applyMask = (mask: string, value: string) => {
  const count = mask.split("_").length - 1;

  if (value && count !== 0 && value.length > 0 && value.length >= count) {
    const maskedSymbols = Array.from(mask.replace(/_/g, ""));

    const unmaskedValue = Array.from(value).filter(
      (val: string) => !maskedSymbols.includes(val)
    );

    // apply mask
    return Array.from(mask)
      .map((val: string) => (val === "_" ? unmaskedValue.shift() : val))
      .join("");
  }
  return value;
};

export type Submit = ({
  onSuccess,
  onError
}: {
  onSuccess?: ((values: Values) => void | unknown | Promise<void>) | undefined;
  onError?: ((errors: Values) => void | unknown | Promise<void>) | undefined;
}) => (e: any) => Promise<unknown> | unknown | undefined;

type Value = any;
type Values = Record<string, Value>;

/**
 * @deprecated Use useFormTyped instead.
 */
export const useForm = (initialValues: Values, validationSchema?: Schema) => {
  const [values, setValues] = useState<Values>(initialValues);
  const [errors, setErrors] = useState<Values>({});
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleChange =
    (
      key: keyof Values,
      customMap?: (v: Value, prev: Value) => Value,
      mask?: string
    ) =>
    (e: any) => {
      const v = customMap ? customMap(e, values[key]) : e.target.value;

      if (!mask) {
        setValues((prev) => ({
          ...prev,
          [key]: v
        }));
      } else {
        // TODO: Doesn't work with customMap

        // count _ in mask
        const maskedValue = applyMask(mask, String(v));
        setValues((prev) => ({
          ...prev,
          [key]: maskedValue
        }));
      }

      setErrors((prev) => ({ ...prev, [key]: undefined }));
    };

  const onSubmit: Submit = ({ onSuccess, onError }) => {
    return (e) => {
      e.preventDefault();
      setIsSubmitting(true);

      if (!validationSchema) {
        return (
          onSuccess &&
          Promise.resolve(onSuccess(values)).finally(() => {
            setIsSubmitting(false);
          })
        );
      }

      validationSchema
        .validate(values, { abortEarly: false })
        .then(() => onSuccess?.(values))
        .catch((e: ValidationError) => {
          const newErrors: Values = e.inner.length
            ? e.inner.reduce(
                (acc: Values, curr: any) => ({
                  ...acc,
                  // TODO: resolve that capitalize(startCase(curr.message))
                  [curr.path]: curr.message
                }),
                {}
              )
            : errors;
          setErrors(newErrors);
          onError?.(newErrors);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    };
  };

  return {
    values,
    errors,
    handleChange,
    onSubmit,
    isSubmitting,
    reset: () => {
      setValues(initialValues);
      setErrors({});
    },
    register: ((key, map, mask) => ({
      name: String(key),
      value: values[key],
      onChange: handleChange(key, map, mask),
      error: errors[key]
    })) as Register
  };
};
